import { get, head } from "lodash";

import BaseProxy from "../../base-proxy";
import BusinessAccountProxy from "./business-account-proxy";
import QueryStringHelper from "@/utilities/query-string-helper";
import LocalStoreManager from "@/utilities/local-store-manager";

export default class VirtualAccountProxy {
  constructor() {
    this.baseProxy = new BaseProxy();
    this.businessAccountProxy = new BusinessAccountProxy();
    this.localStore = new LocalStoreManager();
  }

  async getBankDetails(business_account_id, currency_account_id) {
    try {
      const response = await this.businessAccountProxy.getAuthenticatedData(
        `/sba/v2/customer/business-accounts/${business_account_id}/currency-accounts/${currency_account_id}/bank-details`
      );

      const data = get(response, "data");
      return data;
    } catch (error) {
      return {
        data: null,
        isResourceResponding: false,
        error,
      };
    }
  }

  async getBusinessAccountDetails() {
    const user_id = this.localStore.getUserId();
    const company_id = this.localStore.getCompanyId();
    try {
      const queryStringHelper = new QueryStringHelper();

      const response = await this.businessAccountProxy.getAuthenticatedData(
        `/sba/v2/customer/business-accounts/me${queryStringHelper.buildQuery({
          user_id,
          company_id,
        })}`
      );

      const data = get(response, "data");
      const errors = get(response, "errors");
      if (errors) {
        throw head(errors);
      }
      return data;
    } catch (error) {
      return {
        data: null,
        isResourceResponding: false,
        error,
      };
    }
  }

  async checkBusinessAccountProcessStatus() {
    const authToken = this.localStore.getToken();
    const company_id = this.localStore.getCompanyId();
    try {
      if (!authToken) {
        throw new Error("Auth token is required.");
      }
      if (!company_id) {
        throw new Error("Company ID is required.");
      }
      const queryStringHelper = new QueryStringHelper();
      const apiURL = await this.baseProxy.getSleekBankBackendUrl();

      const response = await this.baseProxy.getAuthenticatedData(
        `${apiURL}/v3/customer/sba-status${queryStringHelper.buildQuery({ company_id })}`,
        authToken
      );

      const data = get(response, "data");
      const errors = get(response, "errors");
      if (errors) {
        throw head(errors);
      }
      return data;
    } catch (error) {
      return {
        data: null,
        isResourceResponding: false,
        error,
      };
    }
  }
}
